'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildPotentialResponders = undefined;

var _immutable = require('immutable');

var _getSendFrom = require('./getSendFrom');

var MAX_POTENTIAL_RESPONDERS = 3;

var buildPotentialResponders = exports.buildPotentialResponders = function buildPotentialResponders(widgetData, responders) {
  var sendFrom = (0, _getSendFrom.getSendFrom)(widgetData);

  var hasAgentResponders = responders && responders.size > 0;
  var hasSendFromResponders = sendFrom && sendFrom.size > 0;

  if (!hasSendFromResponders && !hasAgentResponders) {
    return (0, _immutable.List)();
  }

  if (hasSendFromResponders) {
    return sendFrom.take(MAX_POTENTIAL_RESPONDERS);
  }

  return responders.take(MAX_POTENTIAL_RESPONDERS);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/widget-data/buildPotentialResponders.js
// module id = 930
// module chunks = 2 3